import { useSidebar } from 'app/state/contexts/SidebarContext';
import { v4 as uuidv4 } from 'uuid';
import { useUser } from 'app/state/contexts';
import { useEditorLiveSection } from 'app/state/contexts/EditorUiContext';
import { useEditorContext } from 'app/state/contexts/EditorContext';
import { useSlate } from 'slate-react';
import { Editor, Range } from 'slate';
import { CustomElement } from 'slate/types/slate';

interface AddCommentProps {
  element: CustomElement;
}

type SelectionRoot = { getSelection: () => Selection | null };

const isSelectionRoot = (node: object): node is SelectionRoot => typeof (node as { getSelection?: unknown }).getSelection === 'function';

export const AddComment = ({ element }: AddCommentProps) => {
  const { user } = useUser();

  const { superId: sectionSuperId } = useEditorLiveSection();

  const editor = useSlate();
  const { shadowHost } = useEditorContext();
  const { setDraftComment, setIsSidebarOpen } = useSidebar();

  const getCitation = () => {
    const shadowRoot = shadowHost?.shadowRoot;
    if (shadowRoot) {
      const root: SelectionRoot = isSelectionRoot(shadowRoot) ? shadowRoot : shadowRoot.ownerDocument;
      const marked = root.getSelection()?.toString().trim();
      if (marked) return marked;
    }
    if (editor.selection && !Range.isCollapsed(editor.selection)) {
      return Editor.string(editor, editor.selection).trim() || null;
    }
    return window.getSelection()?.toString().trim() || null;
  };

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const citation = getCitation();
    const commentId = uuidv4();
    const newComment = {
      id: commentId,
      sectionSuperId: sectionSuperId,
      onType: element.type,
      onId: element.uuid,
      message: '',
      userId: user?.id,
      citation,
      closedAt: null,
      createdAt: new Date(),
      updatedAt: null,
      publishedAt: null,
      responses: [],
      user: {
        firstName: user?.firstName,
        lastName: user?.lastName,
        email: user?.email,
      },
    };
    setDraftComment(newComment);
    setIsSidebarOpen(5);
  };

  return (
    <div className="comment--add-coment" onMouseDown={handleClick} onClick={(e) => e.stopPropagation()}>
      <i className="fa-regular fa-message-plus" />
    </div>
  );
};
